var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-sheet',_vm._g({staticClass:"pt-1 pb-1 pl-3 pr-3",attrs:{"rounded":"","value":_vm.value,"color":_vm.statusBoxColor}},on),[_vm._v("\n            "+_vm._s(_vm.value.toUpperCase())+"\n        ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }